function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.444 57.084H8.5c-1.688 0-3.056-1.249-3.056-2.79 0-.357.075-.7.21-1.015l11-25.658c.444-1.037 1.552-1.772 2.846-1.772h46.444c1.688 0 3.056 1.248 3.056 2.788 0 .359-.075.701-.21 1.016l-11 25.657c-.444 1.039-1.551 1.774-2.846 1.774h-1.833",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 48.16V16.923c0-1.848 1.641-3.346 3.667-3.346H31.53c1.297 0 2.54-.47 3.457-1.308l3.247-2.964C39.152 8.47 40.395 8 41.692 8h12.641C56.36 8 58 9.498 58 11.347v3.346",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.738 33.657l4.96-11.568a3 3 0 012.758-1.818h33.988M58 20.271h1.222M64.111 20.271H62.89M23.778 8H25M9.111 8h8.556M42.321 50.435l-6.732-.05c-.577-.004-1.042-.435-1.037-.962l.075-8.51M36.985 33.811c-.365-.023.373-.034 0-.034h-1.107",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.316 34C24.813 35.667 20 41.647 20 48.769 20 57.18 26.715 64 35 64s15-6.819 15-15.231c0-5.547-2.92-10.402-7.285-13.065",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgHistoric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/historic.svg";
export { SvgHistoric as ReactComponent };